'use client';

import Link from 'next/link';
import {Play} from 'lucide-react';
import {Button} from '@manaboo/ui/button';
import type {Campaigns, Games} from '@manaboo/db/types';
import {insertGamesPlayClick} from '@/actions/insert-games-play-click';

interface PropsButtonPlay {
	game_id: Games['id'];
	campaign_id: Campaigns['id'] | null;
	provider_game_id: Games['provider_game_id'];
}

export function ButtonPlay({game_id, campaign_id, provider_game_id}: PropsButtonPlay) {
	return (
		<Link
			href={`https://www.roblox.com/games/start?placeId=${provider_game_id}`}
			target="_blank"
			onClick={async () => {
				await insertGamesPlayClick({
					game_id,
					campaign_id,
				});
			}}
		>
			<Button data-testid="games-play-button">
				<Play className="mr-1 h-4 w-4" />
				Graj teraz
			</Button>
		</Link>
	);
}
